<!-- 新闻列表 -->
<template>
  <div class="component-news-list">
    <div class="all-content">
      <!-- 内容说明 开始 -->
      <div class="content">
        <!-- {{ jxhl.basicContent | htmlfilter }} -->
      </div>
      <!-- 内容说明 结束 -->
      <div class="video">
        <div class="img">
          <div
            class="contents"
            :class="{
              contentsmobile: isphone,
              contentspc: isphone == false
            }"
          >
            <!-- <img src="../assets/images/videobtn.png" alt="" srcset="" /> -->
            <div class="xhtitle">{{ jxhl.basicTitle }}</div>
            <!-- <div class="guankan noselect">立即看直播</div> -->
            <button
              data-v-a6e8bd5a=""
              class="guankan noselect"
              @click="lookvideo(jxhl.basicSource)"
            >
              立即看直播
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComponentNewsList",
  props: ["jxhl"],
  filters: {
    htmlfilter: function(val) {
      return val.replace(/<[^>]*>/g, "");
    }
  },
  data() {
    return {
      isphone: false
    };
  },
  mounted() {
    if (this.isMobile()) {
      this.isphone = true;
    } else {
      this.isphone = false;
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    lookvideo(basicSource) {
      window.open(basicSource);
    }
  }
};
</script>

<!-- 组件独有样式 -->
<style scoped>
.component-news-list {
  width: 1200px;
  min-width: 1200px;
  height: 400px;
  background-color: #ffffff;
  border-radius: 15px;
  margin-top: 18px;
}
.all-content {
  width: 1140px;
  height: 400px;
  position: relative;
  margin: 0 auto;
  top: 30px;
}

.content,
.video {
  width: 1140px;
  margin: 0 auto;
  position: relative;
}
.content {
  width: 1030px;
  top: 20px;
  text-align: justify;
  line-height: 1.7em;
  /*文字缩进*/
  text-indent: 2em;
  font-size: 16px;
  font-family: "宋体";
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.video {
  height: 275px;
  top: 40px;
}
.video .img {
  width: 100%;
  height: 100%;
  text-align: center;
  background: url(../assets/images/zhibo.jpg);
  background-size: 100%;
  float: left;
  position: absolute;
  z-index: 1;
}

.contentspc {
  position: relative;
  top: 30%;
}
.contentsmobile {
  position: relative;
  top: 10px;
}
.contentsmobile button {
  padding: 14px 22px;
  cursor: pointer;
  background-color: var(--main-color);
  border: 0;
  font-size: 12px;
  top: 40px;
  position: relative;
  color: #fff;
  box-sizing: border-box;
}
.contents img {
  width: 51px;
  cursor: pointer;
  transition: all 0.4s;
  opacity: 0.8;
}
.contents img:active {
  opacity: 0.5;
}
.contents img:hover {
  opacity: 1;
}
.contents .xhtitle {
  font-size: 30px;
  position: relative;
  color: #fff;
}
.contentspc .xhtitle {
  top: 10px;
}
.contentsmobile .xhtitle {
  top: 20px;
}
.contentspc .guankan {
  width: 160px;

  cursor: pointer;
  position: relative;
  color: #fff;
  padding: 10px 20px;
  background-color: red;
  margin: 0 auto;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.9);
  transition: all 0.4s;
}
.contentspc .guankan {
  top: 30px;
}
.contentspc button {
  padding: 14px 28px;
  cursor: pointer;
  background-color: var(--main-color);
  border: 0;
  font-size: 22px;
  color: #fff;
  box-sizing: border-box;
}
.contents .guankan:active {
  transition: width 3s;
  -moz-transition: width 3s; /* Firefox 4 */
  -webkit-transition: width 3s; /* Safari and Chrome */
  -o-transition: width 3s; /* Opera */
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.9);
}
.contents .guankan:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/xianhua.vue